import { motion } from "framer-motion";
import { Crown, Compass, Briefcase, Calculator, ShoppingCart } from "lucide-react";

const LEADERSHIP = [
  {
    name: "Billy Joe B. Dijamco",
    role: "Proprietor / Owner",
    bio: "Founder of the modern consumer-goods venture; brings dynamic trading strategy and a deep network across FMCG suppliers and retailers.",
    Icon: Crown,
    accent: "from-blue-600 to-emerald-500",
  },
  {
    name: "Liam D. Yu",
    role: "Operation Director",
    bio: "Owns end-to-end operations — from warehousing and inventory accuracy to last-mile distribution across the regional network.",
    Icon: Compass,
    accent: "from-emerald-500 to-emerald-600",
  },
  {
    name: "Ma. Giselle V. Garcia",
    role: "Managing Director",
    bio: "Carries the management legacy forward — designing the administrative frameworks and partner programs that keep the business disciplined and scalable.",
    Icon: Briefcase,
    accent: "from-blue-500 to-blue-600",
  },
  {
    name: "Jessa Mae R. Ragojo",
    role: "Finance & Accounting Officer",
    bio: "Stewards the financial discipline of the business — credit terms, cash flow, and the cost controls that make competitive pricing possible.",
    Icon: Calculator,
    accent: "from-violet-500 to-violet-600",
  },
  {
    name: "Marc D. Francisco",
    role: "Purchasing Officer",
    bio: "Leads vendor selection and procurement — sourcing the right SKUs, at the right terms, from the right manufacturers, on time, every cycle.",
    Icon: ShoppingCart,
    accent: "from-amber-500 to-amber-600",
  },
];

export default function Leadership() {
  return (
    <section id="leadership" data-testid="leadership-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl mb-14"
        >
          <p className="text-sm uppercase tracking-widest font-semibold text-emerald-600 mb-3">Leadership</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-semibold text-slate-900">
            The team driving operational excellence.
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            A dedicated leadership core executing the foundational values of efficiency, quality, and integrity daily.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {LEADERSHIP.map((p, i) => (
            <motion.article
              key={p.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              data-testid={`leader-${p.name.replace(/[^a-zA-Z]/g, "-").toLowerCase()}`}
              className="group bg-white border border-slate-200 hover:border-blue-200 rounded-2xl p-7 hover:shadow-xl hover:-translate-y-1 transition-all"
            >
              <div className="flex items-start gap-4 mb-5">
                <div className={`shrink-0 w-14 h-14 rounded-xl bg-gradient-to-br ${p.accent} text-white flex items-center justify-center shadow-md`}>
                  <p.Icon size={22} strokeWidth={2.2} />
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading text-lg font-semibold text-slate-900 leading-tight">{p.name}</h3>
                  <p className="text-xs text-blue-600 font-semibold uppercase tracking-wider mt-1">{p.role}</p>
                </div>
              </div>
              <p className="text-sm text-slate-600 leading-relaxed">{p.bio}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
